/**
 * Replace tokens within a settings object.
 * @param {object} obj Settings object
 * @param {string} placeholder Text to perform replace on
 * @param {string} value Value to use in replacement
 * @returns {void}
 */
export function replaceToken(obj, placeholder, value) {
  if (!obj) return;

  for (let key in obj) {
    if (typeof obj[key] === "string") {
      if (obj[key].includes(placeholder)) {
        const regex = new RegExp(
          placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
          "g",
        );
        // const originalValue = obj[key];

        obj[key] = obj[key].replace(regex, value);

        // If we wanted to include tokens in the view_rule_id that needed to be
        // replaced in the browser to avoid server cache then need to inform
        // scripts that create ID promises when this changes. May result in
        // the ID returned from the promise changing.
        // if (obj[key] !== originalValue) {
        //   window.dispatchEvent(
        //     new CustomEvent("AnalyticsTokenUpdate", {
        //       detail: {
        //         key,
        //       },
        //     }),
        //   );
        // }
      }
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      replaceToken(obj[key], placeholder, value);
    }
  }
}
